var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card card-certificate" }, [
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-4 card-name" }, [_vm._v("Nombre")]),
        _c("div", { staticClass: "col-8 card-value" }, [
          _vm._v(_vm._s(_vm.user.nombre))
        ]),
        _c("div", { staticClass: "col-4 card-name" }, [_vm._v("Cargo")]),
        _c("div", { staticClass: "col-8 card-value" }, [
          _vm._v(_vm._s(_vm.user.cargo || "-"))
        ]),
        _c("div", { staticClass: "col-4 card-name" }, [_vm._v("Departamento")]),
        _c("div", { staticClass: "col-8 card-value" }, [
          _vm._v(_vm._s(_vm.user.departamento || "-"))
        ]),
        _c("div", { staticClass: "col-4 card-name" }, [_vm._v("Empresa")]),
        _c("div", { staticClass: "col-8 card-value" }, [
          _vm._v(_vm._s(_vm.company.razonSocial || "-"))
        ]),
        _c("div", { staticClass: "col-4 card-name" }, [
          _vm._v("Fecha Creación")
        ]),
        _c("div", { staticClass: "col-8 card-value" }, [
          _vm._v(_vm._s(_vm.certificate.fechaCreacion || "-"))
        ]),
        _c("div", { staticClass: "col-4 card-name" }, [
          _vm._v("Fecha Vencimiento")
        ]),
        _c("div", { staticClass: "col-8 card-value" }, [
          _vm._v(_vm._s(_vm.certificate.fechaCaducidad || "-"))
        ]),
        _c("div", { staticClass: "col-4 card-name" }, [_vm._v("Estado")]),
        _vm.certStatus.CREATE == _vm.certificate.estado
          ? _c("div", { staticClass: "col-8 card-value" }, [
              _vm._v(" Creado Pendiente de activación ")
            ])
          : _vm.certStatus.ACTIVE == _vm.certificate.estado
          ? _c("div", { staticClass: "col-8 card-value" }, [_vm._v(" Activo ")])
          : _c("div", { staticClass: "col-8 card-value" }, [
              _vm._v(" No disponible ")
            ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }